class TextInput {
  constructor($scope, $timeout) {
    'ngInject';
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.isTyping = false;
  }

  $onInit() {
    this.width = this.sWidth ? {width: this.sWidth} : null;
    this.type = this.sIsPassword ? 'password' : 'text';
    this.debounce = this.sDebounce || 750;
    if(this.sValidate && !Array.isArray(this.sValidate)) {
      this.sValidate = [this.sValidate];
    }
    const validationErrors = this.validate();
    this.$scope.$emit('kovFormElemChanged', {
      onInitPhase: true,
      value: this.sModel,
      errors: validationErrors
    });

    // broadcast event from component that uses form to indicate that a new entity is selected and form needs to be reset (no errors from previous enitity should be left hanging)
    /* this.$scope.$on('resetFormValidation', () => {
      this.validatedSinceReset = false;
      this.$timeout(() => {
        // give time for bindings to be set
        if (!this.validatedSinceReset) {
          // When a new entity is loaded in the form and this formcomponent is empty or hidden on the screen we need to make sure it is validated again.
          const validationErrors = this.validate();
          this.$scope.$emit('kovFormElemChanged', {
            onInitPhase: true,
            value: this.sModel,
            errors: validationErrors
          });
        }
      }, 1500);
    }); */
  }

  keyPressed() {
    if(!this.isTyping) {
      this.isTyping = true;
      this.$scope.$emit('kovFormElemStartTyping', this.sModel);
    }
  }

  validate() {
    this.validatedSinceReset = true;
    const errors = [];
    if(this.sRequired && !this.sModel) {
      errors.push({
        code: 'required',
        message: this.sRequired.message
      });
      return errors;
    }
    if(!this.sModel) {
      return [];
    }
    if (this.sMinLength) {
      const minLength = this.sMinLength.length || this.sMinLength;
      if (this.sModel.length < minLength) {
        errors.push({
          code: 'min.length',
          message: this.sMinLength.message,
          minLength,
          maxLength: this.sMaxLength ? this.sMaxLength.length || this.sMaxLength : undefined
        });
        return errors;
      }
    }
    if (this.sMaxLength) {
      const maxLength = this.sMaxLength.length || this.sMaxLength;
      if (this.sModel.length > maxLength) {
        errors.push({
          code: 'max.length',
          message: this.sMaxLength.message,
          maxLength
        });
        return errors;
      }
    }
    if (this.sPattern) {
      const pattern = this.sPattern.pattern || this.sPattern;
      if(!new RegExp(pattern).test(this.sModel)) {
        errors.push({
          code: 'pattern',
          message: this.sPattern.message
        });
        return errors;
      }
    }
    if(this.sValidate) {
      this.sValidate.forEach(validateObj => {
        const validateFunction = validateObj.validate || validateObj;
        const extraArguments = validateObj.args ? validateObj.args : [];
        const error = validateFunction(this.sModel, ...extraArguments);
        if(error) {
          errors.push({
            code: error.code,
            message: error.message
          });
          if(error.stopValidation) {
            return errors;
          }
        }
      });
    }
    return errors;
  }

  onChange() {
    this.isTyping = false;
    const validationErrors = this.validate();
    this.$scope.$emit('kovFormElemChanged', {
      value: this.sModel,
      errors: validationErrors
    });
    this.$scope.$emit('onChange', this.sModel);
  }

  $onChanges(bindings){
    if(bindings.sModel && bindings.sModel.currentValue) {
      // console.log('Ik krijg hier een on-change event voor s-model', bindings);
      const validationErrors = this.validate();
      this.$scope.$emit('kovFormElemChanged', {
        value: bindings.sModel.currentValue,
        errors: validationErrors
      });
    }
  }

  onChangeEmitter() {
    this.onChange();
  }

  onBlur() {
    this.$scope.$emit('kovFormElemLeft');
  }
}

module.exports = {
  template: require('./kovTextInput.html'),
  controller: TextInput,
  controllerAs: 'ctrl',
  transclude: false,
  bindings: {
    sModel: '<',
    sPlaceholder: '@',
    sRequired: '<',
    sMinLength: '<',
    sMaxLength: '<',
    sPattern: '<',
    sIsPassword: '<',
    sValidate: '<',
    sDisabled: '<',
    sDebounce: '<',
    sWidth: '@'
  }
};
